import MuiAccordionSummary from '@mui/material/AccordionSummary';
import colors from '../../../assets/colors';
import { styled } from '@mui/system';

const AccordionSummary = styled(MuiAccordionSummary)({
  '&.MuiAccordionSummary-root': {
    backgroundColor: colors.oldAgroweGreen,
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    color: colors.white,
    marginBottom: -1,
    minHeight: 56,
    paddingLeft: 25,
    overflowWrap: 'anywhere',
    hyphens: 'auto',
    '&.Mui-expanded': {
      minHeight: 56,
    },
  },
  '&.MuiAccordionSummary-content': {
    '&.Mui-expanded': {
      margin: '12px 0',
    },
  },
});

export default AccordionSummary;
